<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import Qs from 'qs'
    let langList = {"en_US":"英文","vi_VN":"越南文"};
    let typeList = {1:"首页精选"};
    export default {
        name: 'knowledge',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    this.$refs.childUpdate.open(row);
                }else if (clickName == "delete"){
                    this.dataChanage(URL.knowledge.delete,{id:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if(window.$t('txmis.bt.add') == clickName){
                    this.$refs.childUpdate.open();
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(URL.knowledge.edit,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                        { title: "id", field: 'id',hidden: true},
                        { title: window.$t('txmis.knowledge.type'), field: 'type',type:2,optionList:typeList,required:true,isNumber:true},
                        { title: window.$t('txmis.knowledge.lang'), field: 'lang',type:2,optionList:langList,required:true},
                        { title: window.$t('txmis.knowledge.title'), field: 'title',required:true},
                        { title: window.$t('txmis.knowledge.sort'), field: 'sort',required:true,type:7},
                        { title: window.$t('txmis.knowledge.url'), field: 'url',required:true},
                        { title: window.$t('txmis.currencySymbol.detail'), field: 'detail',type:14,required:true},
                    ],
                },
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                      {click:window.$t('txmis.bt.search')},
                      {click:window.$t('txmis.bt.add')},
                  ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.knowledge.queryList, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title: window.$t('txmis.knowledge.type'), field: 'type',render:(data,full)=> {
                                return typeList[data];
                            }},
                        { title: window.$t('txmis.knowledge.lang'), field: 'lang',render:(data,full)=> {
                                return langList[data];
                            }},
                        { title: window.$t('txmis.knowledge.title'), field: 'title'},
                        { title: window.$t('txmis.knowledge.sort'), field: 'sort'},
                        { title: window.$t('txmis.knowledge.url'), field: 'url'},
                        {field:window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-edit"},
                        {field:window.$t('txmis.bt.delete'),title:window.$t('txmis.bt.operation'),size:"mini",click:"delete",type:"primary",icon:"el-icon-delete"},
                    ]
                }
            }
        }
    }
</script>
